// extracted by mini-css-extract-plugin
export var container = "background-module--container--1ddb1";
export var drawingApp = "background-module--drawing-app--23bb1";
export var logo = "background-module--logo--b23d2";